<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('ITEM.EDIT') }} {{ $t('ORDERS.ITEM') }}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>
    <v-card class="mt-3" :loading="loading">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <order-business-form
              v-if="isLoadedOrder"
              v-model="order"
              :company="company"
              :errors="errors.getAll()"
              :action="action"
              editable
              @valid="valid = $event"
              @update-prop="clearErrorByName($event)"
            ></order-business-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              large
              class="float-right"
              color="success"
              :disabled="!valid"
              @click="confirmUpdate"
              >{{ $t('BUTTON.UPDATE') }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <confirm-dialog ref="confirm"></confirm-dialog>
  </v-container>
</template>

<script>
import order from '../mixins/order';
import errors from '@/modules/_global/mixins/errors';
import OrderBusinessForm from './../../components/forms/OrderBusinessForm.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { CANCELLED } from '../../common/statuses';
import { EDIT } from '@/modules/_global/mixins/form-editable';

export default {
  name: 'BusinessOrderEditPage',

  components: {
    OrderBusinessForm,
    ConfirmDialog: () => import('@/modules/_global/_components/ConfirmDialog')
  },

  mixins: [errors, order],

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    company: {},
    valid: false,
    action: EDIT
  }),

  computed: {
    ...mapGetters(['loading']),
    ...mapState('order', ['currentOrder'])
  },

  mounted() {
    this.$vuetify.goTo(0);
    this.getOrderB({ orderId: this.id }).then(({ data }) => {
      this.company = data.company;
      this.order = data;
    });
  },

  methods: {
    ...mapActions('order', ['getOrderB', 'updateOrderB']),
    confirmUpdate() {
      if (
        this.order.status_id === CANCELLED &&
        this.currentOrder.status_id !== this.order.status_id
      ) {
        this.$refs.confirm
          .open(this.$t('ORDERS.UPDATE_CONFIRMATION_QUESTION'), null, {
            cancelBtnText: this.$t('ORDERS.UPDATE_CONFIRMATION_CANCEL_BUTTON'),
            agreeBtnText: this.$t('ORDERS.UPDATE_CONFIRMATION_AGREE_BUTTON')
          })
          .then(confirm => {
            if (confirm) {
              this.update();
            }
          });

        return;
      }

      this.update();
    },
    update() {
      this.updateOrderB({ orderId: this.id, order: this.order })
        .then(() => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$router.go(-1);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
